<template>
  <div class="school-user-groups ma-0 p-3" >
    <v-card>
      <v-row class="mt-2">
        <v-col class="d-flex justify-start">
          <h6 class="mx-3">
            {{ $t("manage.by_school.user.user_group.show_header") }}
          <v-radio-group 
            v-if="$i18n.locale=='tc'" 
            class="mt-0"
            v-model="viewGroupStatus"
            row 
            dense
            @change="showActiveGroups()"
          >
            <v-radio
              label="有效"
              value="ACTIVE"
            ></v-radio>
            <v-radio
              label="已停用"
              value="INACTIVE"
            ></v-radio>
          </v-radio-group>
          <v-radio-group 
            v-else
            class="mt-0"
            v-model="viewGroupStatus" 
            row 
            dense
            @change="showInactiveGroups()"
          >
            <v-radio
              label="ACTIVE"
              value="ACTIVE"
            ></v-radio>
            <v-radio
              label="INACTIVE"
              value="INACTIVE"
            ></v-radio>
          </v-radio-group>
          </h6>
          <v-spacer></v-spacer>
          <v-btn class="ml-auto mr-3 green lighten-4" @click="dialog_add_group = !dialog_add_group">
            <v-icon left> mdi-plus </v-icon>
            {{ $t("manage.by_school.user.user_group.btn_add_user_group") }}
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        dense
        :locale="localeTranslate()"
        :search="search"
        :headers="userGroupLabel('header')"
        :items="api.groups" 
        item-key="id"
        :items-per-page="-1">
        <template v-slot:top>
            <v-text-field
            v-model="search"
            :label="userGroupLabel('search')"
            class="mx-4"
            ></v-text-field>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip top color="blue darken-2">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="viewUserGroup(item)">
                <v-icon color="blue darken-2"> mdi-account-box-multiple </v-icon>
              </v-btn>
            </template>
            <span>{{ $t("manage.by_school.user.user_group.btn_view_group") }}<small><br>{{ $t("manage.by_school.user.user_group.view_group_hint_1") }}<br>{{ $t("manage.by_school.user.user_group.view_group_hint_2") }}</small></span>
          </v-tooltip>

          <v-tooltip top color="grey">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="viewGroupAssignment(item)">
                <v-icon >mdi-book-cog-outline </v-icon>
              </v-btn>
            </template>
            <span>{{ $t("manage.by_school.user.user_group.btn_assigned_period") }}<small><br>{{ $t("manage.by_school.user.user_group.assigned_period_hint_1") }}<br>{{ $t("manage.by_school.user.user_group.assigned_period_hint_2") }}</small></span>
          </v-tooltip>

          <v-tooltip v-if="viewGroupStatus=='ACTIVE'" top color="red accent-2">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="openInactiveGroupDialog(item)">
                <v-icon color="red accent-2">mdi-pause-circle </v-icon>
              </v-btn>
            </template>
            <span>{{ $t("manage.by_school.user.user_group.btn_inactive_group") }}</span>
          </v-tooltip>

          <v-tooltip v-else-if="viewGroupStatus=='INACTIVE'" top color="light-blue lighten-1">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="openActiveGroupDialog(item)">
                <v-icon color="light-blue lighten-1">mdi-replay </v-icon>
              </v-btn>
            </template>
            <span>{{ $t("manage.by_school.user.user_group.btn_active_group") }}</span>
          </v-tooltip>

          <!--v-icon class="mr-2" color="blue darken-2" @click="viewUserGroup(item)"> mdi-account-box-multiple </v-icon>
          <v-icon class="mr-2"  @click="viewGroupAssignment(item)"> mdi-book-cog-outline </v-icon-->
          
        </template>
      </v-data-table>
    </v-card>
    <v-card class="mt-3">
      <div class="book_slot_panel py-3" v-if="slot_view_book_slot" >
        <v-row class="mt-2">
          <v-col class="ml-4">
            <h6>{{ $t("manage.by_school.user.user_group.header_assigned_period") }}</h6>
          </v-col>
          <v-col class="d-flex justify-start">
            <v-btn class="ml-auto mr-3 green lighten-4" @click="openAssignBookSlotDialog(viewAssignmentItem)">
              <v-icon left> mdi-plus </v-icon>
              {{ $t("manage.by_school.user.user_group.btn_assigned_period") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-breadcrumbs v-if="$i18n.locale=='tc'" class='pt-0' :items="breadcrumbs_user_chi" large></v-breadcrumbs>
        <v-breadcrumbs v-else class='pt-0' :items="breadcrumbs_user" large></v-breadcrumbs>
        <v-data-table
          dense
          :locale="localeTranslate()"
          :headers="headers_book_slots"
          :items="api.assigns"
          item-key="id"
          :sort-by="['start_date', 'open_time']"
          :sort-desc="[true, true]"
          :items-per-page="10"
          multi-sort
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip v-if='item.status!="CANCELLED"' top color="red lighten-1">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="removeUserGroupFromBookSlot(item)">
                <v-icon color="red lighten-1"> mdi-book-remove-outline </v-icon>
              </v-btn>
            </template>
            <span>Unassign to Period</span>
          </v-tooltip>
            <!--v-icon v-if='item.status!="CANCELLED"' class="mr-2" color="red lighten-1" @click="removeUserGroupFromBookSlot(item)"> mdi-book-remove-outline </v-icon-->
          </template>
        </v-data-table>
      </div>
      <div class="user_panel py-3" v-if="slot_view_user" >
        <v-row class="mt-2">
          <v-col class="ml-4">
            <h6>{{ $t("manage.by_school.user.user_group.header_view_group") }}</h6>
          </v-col>
          <v-spacer></v-spacer>
          <v-btn class="mr-3 red lighten-5" @click="openClearGroupDialog(usersItem)">
            <v-icon left> mdi-account-remove </v-icon>
            {{ $t("manage.by_school.user.user_group.view_group.btn_clear_group") }}
          </v-btn>
          <v-btn class="mr-6 green lighten-4" @click="openImportUserDialog()">
            <v-icon left> mdi-import </v-icon>
            {{ $t("manage.by_school.user.user_group.view_group.btn_import_user") }}
          </v-btn>
        </v-row>
        <v-breadcrumbs v-if="$i18n.locale=='tc'" class='pt-0' :items="breadcrumbs_user_chi" large></v-breadcrumbs>
        <v-breadcrumbs v-else class='pt-0' :items="breadcrumbs_user" large></v-breadcrumbs>
        <v-row>
          <v-col>
              <v-data-table
                dense
                :locale="localeTranslate()"
                :headers="userLabel('header')"
                :items="api.users"
                item-key="id"
                :sort-by="['start_at']"
                :items-per-page="10"
              >
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip top color="red lighten-1">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" @click="openRemoveUserDialog(item)">
                      <v-icon small color="red lighten-1"> mdi-account-minus </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("manage.by_school.user.user_group.view_group.btn_ungroup") }}</span>
                </v-tooltip>
                <!--v-icon small class="mr-2" color="red lighten-1" @click="openRemoveUserDialog(item)"> mdi-account-minus </v-icon-->
              </template>
              </v-data-table>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <v-dialog v-model="dialog_add_group" fullscreen hide-overlay>
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="dialog_add_group = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("manage.by_school.user.user_group.add_user_group.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11" md="8" lg="6" class="my-2 px-1">
            <v-row>
              <v-col cols="12">
                <v-select
                  :items="api.schools"
                  item-text="school_id"
                  item-value="school_id"
                  v-model="form.school"
                  :label="addUserGroupLabel('school_label')"
                  readonly
                ></v-select>
              </v-col>
              <v-col>
                <v-text-field
                  :label="addUserGroupLabel('group_name')"
                  v-model="form.new_group"
                ></v-text-field>
              </v-col>
              <v-col v-if=0>
                <v-select
                  :items="api.hosts"
                  item-text="text"
                  item-value="value"
                  v-model="form.host"
                  label="Host/Guest"
                ></v-select>
              </v-col>
            </v-row>
            <hr>
            <v-btn class="ma-4" @click="addSchoolUserGroup">
              {{ $t("manage.by_school.user.user_group.add_user_group.btn_add") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_import_user" fullscreen hide-overlay>
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="dialog_import_user = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("manage.by_school.user.user_group.view_group.import_user.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11" md="8" lg="6" class="my-2 px-1">
            <v-row>
              <v-col cols="12">
                <v-select
                  :items="api.schools"
                  item-text="school_id"
                  item-value="school_id"
                  v-model="form.school"
                  :label="importUserLabel('school_label')"
                  readonly
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  :items="api.groups"
                  item-text="user_group"
                  item-value="user_group"
                  v-model="form.groups.group"
                  :label="importUserLabel('group_label')"
                  readonly
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-file-input
                  accept="text/csv"
                  :label="importUserLabel('file')"
                  :placeholder="importUserLabel('file_place_hloder')"
                  v-model="form.upload_file"
                >
                </v-file-input>
              </v-col>
              <v-col cols="12">
                <v-card class="p-1">
                  <small>{{ $t("manage.by_school.user.user_group.view_group.import_user.template_file_text") }}</small>
                  <br>
                  <div v-for="(item, i) in api.templates" :key="i">
                    <a class=" grey--text text--darken-1" :href="item.src" target="_BLANK"><v-icon class="p-1" color="grey darken-1">mdi-download</v-icon>{{ item.filename }}</a>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <hr>
            <v-btn class="ma-4" @click="importUsers">
              {{ $t("manage.by_school.user.user_group.view_group.import_user.btn_import") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="removeUserDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("manage.by_school.user.user_group.view_group.ungroup.header") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("manage.by_school.user.user_group.view_group.ungroup.username") }}</th>
              <td>{{ removeUserItem.username }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("manage.by_school.user.school") }}</th>
              <td>{{ current.school_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("manage.by_school.user.user_group.view_group.ungroup.user_group") }}</th>
              <td>{{ removeUserItem.user_group }}</td>
            </tr>
          </table>
          <hr>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="closeRemoveUserDialog()"
          >
            Discard
          </v-btn>
          <v-btn
            color="red lighten-1"
            text
            @click="removeUserFromUserGroup(removeUserItem)"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_assign_book_slot" fullscreen hide-overlay>
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="dialog_assign_book_slot = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Assign to Booking Period</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11" class="my-2 px-1">
            <v-row>
              <v-col cols="12">
                <v-select
                  :items="api.schools"
                  item-text="school_id"
                  item-value="school_id"
                  v-model="form.school"
                  label="School"
                  readonly
                ></v-select>
              </v-col>
              <v-col>
                <v-text-field
                  label="Group Name"
                  v-model="form.groups.group"
                  readonly
                  disabled
                ></v-text-field>
              </v-col>
              <v-col v-if=0>
                <v-select
                  :items="api.hosts"
                  item-text="text"
                  item-value="value"
                  v-model="form.groups.host"
                  label="Host/Guest"
                  readonly
                ></v-select>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-data-table
                dense
                :locale="localeTranslate()"
                v-model="selected"
                :headers="headers_ongoing_book_slots"
                :items="api.ongoing_book_slots"
                item-key="ref"
                show-select
                :sort-by="['ref']"
                :items-per-page="-1"
              >
              </v-data-table>
            </v-row>
            <hr>
            <v-btn class="ma-4" @click="assignGroupToBookSlot(selected)">
              Assign to Period
            </v-btn>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_clear_group" width="600" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2">
          {{ $t("manage.by_school.user.user_group.view_group.clear_group.header") }}
        </v-card-title>
        <v-card-text>
          <v-alert class="mt-4" type="error"
            >{{ $t("manage.by_school.user.user_group.view_group.clear_group.alert") }}
          </v-alert>
          {{ $t("manage.by_school.user.user_group.view_group.clear_group.user_group_text") }} <b>{{ form.groups.group }}</b>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeClearGroupDialog">{{ $t("manage.by_school.user.user_group.view_group.clear_group.btn_discard") }}</v-btn>
          <v-btn color="grey darken-2" text @click="clearUserGroup">{{ $t("manage.by_school.user.user_group.view_group.clear_group.btn_confirm") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="inactiveGroupDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("manage.by_school.user.user_group.inactivate.header") }}
        </v-card-title>
        <v-alert
          type="error"
          prominent
          border="left"
        >
          {{ $t("manage.by_school.user.user_group.inactivate.alert") }}          
        </v-alert>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("manage.by_school.user.user_group.inactivate.school") }}</th>
              <td>{{ inactiveGroupItem.school_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("manage.by_school.user.user_group.inactivate.user_group") }}</th>
              <td>{{ inactiveGroupItem.user_group }}</td>
            </tr>
          </table>
          <hr>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="closeInactiveGroupDialog()"
          >
            {{ $t("manage.by_school.user.user_group.inactivate.btn_discard") }}
          </v-btn>
          <v-btn
            color="red lighten-1"
            text
            @click="inactiveUserGroup(inactiveGroupItem)"
          >
            {{ $t("manage.by_school.user.user_group.inactivate.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="activeGroupDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("manage.by_school.user.user_group.activate.header") }}
        </v-card-title>
        <v-alert
          type="info"
          outlined
          prominent
          border="left"
        >
          {{ $t("manage.by_school.user.user_group.activate.alert") }}          
        </v-alert>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("manage.by_school.user.user_group.activate.school") }}</th>
              <td>{{ activeGroupItem.school_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("manage.by_school.user.user_group.activate.user_group") }}</th>
              <td>{{ activeGroupItem.user_group }}</td>
            </tr>
          </table>
          <hr>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="closeActiveGroupDialog()"
          >
            {{ $t("manage.by_school.user.user_group.activate.btn_discard") }}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="activeUserGroup(activeGroupItem)"
          >
            {{ $t("manage.by_school.user.user_group.activate.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import { api_management } from "@/services/iot/api_management";
const apiManagement = new api_management(process.env.VUE_APP_BASE_URL);

export default {
  name: "experiment",
  components: {
  },
  mixins: [],
  data: function () {
    return {
      selected: [],
      dialog_add_group: false,    
      dialog_add_user: false,
      dialog_import_user: false,
      dialog_assign_book_slot: false,
      dialog_clear_group: false,
      inactiveGroupDialog: false,
      activeGroupDialog: false,
      search: '',
      slot_view_book_slot: false,
      slot_view_user: false,
      removeUserDialog: false,
      book_slot_panel: [],
      user_panel: [],
      breadcrumbs: [],
      breadcrumbs_user: [],
      breadcrumbs_user_chi: [],
      inactiveGroupItem: {},
      activeGroupItem: {},
      usersItem: {},
      removeUserItem: {},
      viewAssignmentItem: {},
      viewGroupStatus: "ACTIVE",
      headers_groups: [
        { text: 'User Group', value: 'user_group' },
        { text: 'User Type', value: 'host' },
        { text: 'Status', value: 'status' },
        { text: 'Create At', value: 'create_at' },
        { text: 'Last Update At', value: 'last_update_at' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      headers_groups_chi: [
        { text: '用戶組別', value: 'user_group' },
        { text: '用戶類型', value: 'host_chi' },
        { text: '狀態', value: 'status_chi' },
        { text: '建立於', value: 'create_at' },
        { text: '最後更新', value: 'last_update_at' },
        { text: '操作', value: 'actions', sortable: false },
      ],
      headers_users: [
        { text: 'Username', value: 'username' },
        { text: 'User Group', value: 'user_group' },
        { text: 'A/C Level', value: 'acc_level' },
        { text: 'Create At', value: 'create_at' },
        { text: 'Last Login At', value: 'last_login_at' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      headers_users_chi: [
        { text: '用戶名稱', value: 'username' },
        { text: '組別', value: 'user_group' },
        { text: '權限等級', value: 'acc_level' },
        { text: '創建於', value: 'create_at' },
        { text: '最後更新', value: 'last_login_at' },
        { text: '操作', value: 'actions', sortable: false },
      ],
      headers_book_slots: [
        { text: 'Ref', value: 'ref' },
        { text: 'School', value: 'school' },
        { text: 'Experiment', value: 'experiment' },
        { text: 'Equipment ID', value: 'equipment_id' },
        { text: 'Start Date', value: 'start_date' },
        { text: 'End Date', value: 'end_date' },
        { text: 'Open Time', value: 'open_time' },
        { text: 'Close Time', value: 'close_time' },
        { text: 'Duration (mins)', value: 'period_time' },
        { text: 'Preparation (mins)', value: 'prepare_time' },
        { text: 'Status', value: 'status' },
        { text: 'Create At', value: 'create_at' },
        { text: 'Update At', value: 'update_at' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      headers_ongoing_book_slots: [
        { text: 'Ref', value: 'ref' },
        { text: 'School', value: 'school' },
        { text: 'Experiment', value: 'experiment' },
        { text: 'Equipment ID', value: 'equipment_id' },
        { text: 'Date', value: 'date' },
        { text: 'Time', value: 'time' },
        { text: 'Duration (mins)', value: 'duration' },
        { text: 'Status', value: 'status' },
        { text: 'Create by', value: 'create_by' },
        { text: 'Update at', value: 'update_at' },
      ],
      api:{
        hosts: [
          {
            text:"Host",
            value:"HOST"
          },
          {
            text:"Guest",
            value:"GUEST"
          },
        ],
        assigns: [],
        schools: [],
        groups: [],
        users: [],
        experiments: [],
        book_slots: [],
        ongoing_book_slots: [],
        templates: [],
      },
      //
      school_id: "",
      role: null,
      drawer: true,
      mini: true,
      dialog: false,
      activeDialog: false,
      activeItems: [
        { status: "ACTIVE" },
        { status: "INACTIVE"}
      ],
      current:{
        school_id: null,
        username: null,
        user_level: "USER",
        auth_token: null,
        experiment: null,
        equipment_id: null,
      },
      admin: false,
      user: [{
        name: null,
        level: null,
      }],
      form: {
        school: "",
        experiment: "",
        equipment_id: "",
        new_group: "",
        host: "HOST",
        group: "",
        upload_file: null,
        groups:{
          group: "",
          host: "",
        }
      },
      title_breadcrumbs: [{ text: 'Title'},],
    };
  },
  mounted: function () {
    var self = this;
    self.current.school_id = self.$route.params.school_id;
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
    self.api.schools = [self.current.school_id];

    self.form.school = self.current.school_id;
    
    self.getSchoolUserGroups();
    
    self.title_breadcrumbs = [
      { text: 'School: ' + self.current.school_id },
    ];
    console.log(self.current);
  },
  methods: {
    localeTranslate(){
      var self = this;
      if(self.$i18n.locale=='tc') return 'zh-tw';
      else return 'en';
    },
    openInactiveGroupDialog(item){
      var self = this;
      self.inactiveGroupItem = item;
      self.inactiveGroupDialog = true;
    },
    closeInactiveGroupDialog(){
      var self = this;
      self.inactiveGroupItem = {};
      self.inactiveGroupDialog = false;
    },
    openActiveGroupDialog(item){
      var self = this;
      self.activeGroupItem = item;
      self.activeGroupDialog = true;
    },
    closeActiveGroupDialog(){
      var self = this;
      self.activeGroupItem = {};
      self.activeGroupDialog = false;
    },
    showActiveGroups(){
      var self = this;
      self.getSchoolUserGroups();
      self.slot_view_book_slot = false;
      self.slot_view_user = false;
    },
    showInactiveGroups(){
      var self = this;
      self.getSchoolUserGroups();
      self.slot_view_book_slot = false;
      self.slot_view_user = false;
    },
    openImportUserDialog(){
      var self = this;
      self.dialog_import_user = true;
      self.getImportUserTemplate();
    },
    addUserGroupLabel(label){
      var self = this;
      if(self.$i18n.locale=='tc') {
        if (label=='school_label') return self.$t("manage.by_school.user.school");
        else if (label=='group_name') return self.$t("manage.by_school.user.user_group.add_user_group.group_name");
      }
      else {
        if (label=='school_label') return self.$t("manage.by_school.user.school");
        else if (label=='group_name') return self.$t("manage.by_school.user.user_group.add_user_group.group_name");
      }
    },
    userGroupLabel(label){
      var self = this;
      if(self.$i18n.locale=='tc') {
        if (label=='search') return self.$t("manage.by_school.user.user_group.search");
        else if (label=='header') return self.headers_groups_chi;
        else if (label=='equipment_id_label') return self.$t("manage.by_school.experiment.list.add_experiment_set.equipment_id_auto");
      }
      else {
        if (label=='search') return self.$t("manage.by_school.user.user_group.search");
        else if (label=='header') return self.headers_groups;
        else if (label=='equipment_id_label') return self.$t("manage.by_school.experiment.list.add_experiment_set.equipment_id_auto");
      }
    },
    userLabel(label){
      var self = this;
      if(self.$i18n.locale == 'tc'){
        if(label=='header') return self.headers_users_chi;
        else if(label=='ungroup') return self.$t("manage.by_school.user.user_group.view_group.btn_ungroup");
      }
      else {
        if(label=='header') return self.headers_users;
        else if(label=='ungroup') return self.$t("manage.by_school.user.user_group.view_group.btn_ungroup");
      }
    },
    importUserLabel(label){
      var self = this;
      if(self.$i18n.locale=='tc') {
        if (label=='school_label') return self.$t("manage.by_school.user.school");
        else if (label=='group_label') return self.$t("manage.by_school.user.user_group.group");
        else if (label=='file') return "新檔案"
        else if (label=='file_place_hloder') return "選擇CSV格式的檔案"
      }
      else {
        if (label=='school_label') return self.$t("manage.by_school.user.school");
        else if (label=='group_label') return self.$t("manage.by_school.user.user_group.group");
        else if (label=='file') return "New File Input"
        else if (label=='file_place_hloder') return "Select file in CSV format"
      }
    },
    viewGroupAssignment(item) {
      var self = this;
      self.viewAssignmentItem = item;
      apiManagement
        .getSchoolGroupAssignments(self.current.school_id, item.user_group, item.host)
        .then((response) => {
          self.api.assigns = response.assigns;
          self.usersItem = {};
          self.slot_view_user = false;
          self.slot_view_book_slot = true;
          self.breadcrumbs_user = [
            { text: "School ID: "+ self.current.school_id },
            { text: "Group: " + item.user_group },
          ];
          self.breadcrumbs_user_chi = [
            { text: "學校ID: "+ self.current.school_id },
            { text: "組別: " + item.user_group },
          ];
          self.panel = [];
          self.book_slot_panel = [0];
          self.form.groups.group = item.user_group;
          self.form.groups.host = item.host;
        });
    },
    getSchoolUserGroups(){
      var self = this;
      apiManagement.getSchoolUserGroups(self.current.school_id, self.viewGroupStatus)
      .then((response) => {
          self.api.groups = response.groups;
      });
    },
    addSchoolUserGroup(){
      var self = this;
      apiManagement.addSchoolUserGroup(self.current.school_id,self.form.new_group,self.form.host)
      .then((response) => {
        if(response.status == "success"){
          self.$store.commit("showSnackBar", "Added New User Group");
          self.dialog_add_group = !self.dialog_add_group;
          self.getSchoolUserGroups();
        }
        else {
          alert(response.message);
        }
      });
    },
    getImportUserTemplate(){
      var self = this;
      apiManagement.getImportUserTemplate()
      .then((response) => {
        if(response.status == "success"){
          self.api.templates = response.templates;
        }
      });
    },
    importUsers(){
      var self = this;
      apiManagement.importUsers(self.current.school_id, self.form.groups.group, self.form.upload_file)
      .then((response) => {
        
        if(response.status == "success"){
          if(response.error!=''){
            self.$store.commit("showSnackBar", "Some user is not added. Please make sure the file is in correct CSV format.");
            self.viewUserGroup(self.usersItem);
          }
          else {
            self.$store.commit("showSnackBar", "Added New User Group");
            self.dialog_import_user = !self.dialog_import_user;
            self.viewUserGroup(self.usersItem);
            
          }
        }
        else if(response.status=="fail"){
          self.$store.commit("showSnackBar", response.message);
        }
        else {
          self.$store.commit("showSnackBar", "Error, please try again.");
        }
      });
    },
    viewUserGroup(item){
      var self = this;
      self.usersItem = item;
      //self.
      apiManagement
        .getUsersByUserGroup(self.current.school_id, item.user_group)
        .then((response) => {
          self.api.users = response.users;
          self.slot_view_book_slot = false;
          self.slot_view_user = true;
          self.breadcrumbs_user = [
            { text: "School: "+ self.current.school_id },
            { text: "Group: " + item.user_group },
          ];
          self.breadcrumbs_user_chi = [
            { text: "學校ID: "+ self.current.school_id },
            { text: "組別: " + item.user_group },
          ];
          self.panel = [];
          self.user_panel = [0];
          self.form.groups.group = item.user_group;
          self.form.groups.host = item.host;

        });
    },
    openAssignBookSlotDialog(item){
      var self = this;
      self.dialog_assign_book_slot = !self.dialog_assign_book_slot;
      self.getSchoolOngoingBookSlots(item);
    },
    closeAssignBookSlotDialog(){
      var self = this;
      self.dialog_assign_book_slot = !self.dialog_assign_book_slot;
    },
    openRemoveUserDialog(item){
      var self = this;
      self.removeUserDialog = !self.removeUserDialog;
      self.removeUserItem = item;
    },
    closeRemoveUserDialog(){
      var self = this;
      self.removeUserDialog = !self.removeUserDialog;
      self.removeUserItem = {};
    },
    removeUserFromUserGroup(item){
      var self = this;      
      apiManagement
        .removeUserFromUserGroup(item.username, item.user_group)
        .then((response) => {
          self.viewUserGroup(self.usersItem);
          if(response.status=='success'){            
            self.$store.commit("showSnackBar", "User has been removed from user group");
            self.removeUserDialog = !self.removeUserDialog;            
            self.removeUserItem = {};
          }
          else {
            self.$store.commit("showSnackBar", response.message);
          }
        });
    },
    removeUserGroupFromBookSlot(item){
      var self = this;      
      apiManagement
        .removeUserGroupFromBookSlot(self.current.school_id, item.group, item.ref)
        .then((response) => {
          self.viewGroupAssignment(self.viewAssignmentItem);
          if(response.status=='success'){
            self.$store.commit("showSnackBar", "User has been removed from user group");
//            self.removeUserDialog = !self.removeUserDialog;
//            self.removeUserItem = {};
          }
          else {
            self.$store.commit("showSnackBar", response.message);
          }
        });
    },
    getSchoolOngoingBookSlots(item){
      var self = this;
      apiManagement.getSchoolOngoingBookSlots(self.current.school_id, item.user_group).then((response) => {
        self.api.ongoing_book_slots = response.ongoing_book_slots;
      });
    },
    assignGroupToBookSlot(selected){
      var self = this;
      if(selected.length == 0){
        alert("No Period is Selected");
      }
      else{
        let i = 0;
        let ids = [];
        while (i < selected.length) {          
          ids.push(selected[i].ref);
          i++;
        }
        apiManagement.assignGroupToBookSlot(self.current.school_id, self.form.groups.group, ids)
        .then((response) => {
          if(response.status == "success"){
            self.dialog_assign_book_slot =false;
            self.selected = [];
            self.$store.commit("showSnackBar", "Assigned to Booking Period");            
            self.viewGroupAssignment(self.viewAssignmentItem);
          }
          else {
            alert(response.message);
          }
        });
      }
    },
    openClearGroupDialog(item){
      var self = this;
      self.dialog_clear_group = !self.dialog_clear_group;
      self.removeUserItem = item;
    },
    closeClearGroupDialog(){
      var self = this;
      self.dialog_clear_group = !self.dialog_clear_group;
      self.removeUserItem = {};
    },
    clearUserGroup(){
      var self = this;
      apiManagement.clearUserGroup(self.form.groups.group)
      .then((response) => {
          if(response.status == "success"){
            self.$store.commit("showSnackBar", "User group is empty.");
            self.dialog_clear_group = !self.dialog_clear_group;
            self.viewUserGroup(self.usersItem);
          }
          else {
            self.$store.commit("showSnackBar", response.message);
            self.viewUserGroup(self.usersItem);
          }
        });
    },
    inactiveUserGroup(item){
      var self = this;
      apiManagement.inactiveUserGroup(item.school_id, item.user_group)
      .then((response) => {
        if(response.status == "fail"){
          self.$store.commit("showSnackBar", response.message);
        }
        else if(response.status=="success") {
          self.$store.commit("showSnackBar", "User Group has been inactivated successfully.");
          self.closeInactiveGroupDialog();
        }
        else {
          self.$store.commit("showSnackBar", "Error. Please try again");
        }
        self.getSchoolUserGroups();
      });
    },
    activeUserGroup(item){
      var self = this;
      apiManagement.activeUserGroup(item.school_id, item.user_group)
      .then((response) => {
        if(response.status == "fail"){
          self.$store.commit("showSnackBar", response.message);
        }
        else if(response.status=="success") {
          self.$store.commit("showSnackBar", "User Group has been re-activated successfully.");
          self.closeActiveGroupDialog();
        }
        else {
          self.$store.commit("showSnackBar", "Error. Please try again");
        }
        self.getSchoolUserGroups();
      });
    },
    back(){
      var self = this;
      self.$cookies.remove("experiment");
      self.$cookies.remove("equipment_id");
      if(self.$route.name == 'admin-school-management'){
        self.$router.push("/admin/management/school/school_list");
      }
      else {
        self.$router.push("/school/school_list");
      }
    },
  },
  destroyed(){
    clearInterval(this.kick_inte);
    console.log("destroyed");
  } 
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>